import deepmerge from 'deepmerge';

import ED from '../../bluestone/ED';
import deprecatedColors from './deprecated';
import derivedColors from '../../cobalt/colors/derived/ED';
import type { Colors } from '../../types';
import baseColors from './base/ED';

const colors: Colors = {
  ...ED.colors,
  ...deepmerge(
    deprecatedColors(baseColors, baseColors.secondary['50']),
    baseColors
  ),
  ...derivedColors(baseColors),
};

export default colors;
